
/**
 * PlantHoverTooltip - Zeigt Pflanzennamen bei Hover über PlantCircle
 *
 * @param {object} props
 * @param {string} props.plantName - Deutscher Pflanzenname
 * @param {{ x: number, y: number }} props.position - Screen-Koordinaten (fixed)
 * @param {boolean} props.visible - Sichtbar?
 */
const PlantHoverTooltip = ({ plantName, position, visible }) => {
  if (!visible || !position || !plantName) return null;

  return (
    <div
      style={{
        position: 'fixed',
        left: `${position.x}px`,
        top: `${position.y}px`,
        transform: 'translate(-50%, -100%) translateY(-8px)',
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    >
      <div className="bg-gray-900/90 text-white text-xs font-medium px-2 py-1 rounded shadow-lg whitespace-nowrap">
        {plantName}
      </div>
    </div>
  );
};

export default PlantHoverTooltip;
